import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import CountryContext from "../CountryContext";
import { Route, useParams, useHistory } from "react-router-dom";
import { NotificationsContext } from "@ui-components/Notifications";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import {ScatterMap} from "@components/Maps/ScatterMap/component";
import { PageHeading } from "../ui-components/Container";
import { useIntl, FormattedMessage } from "react-intl";
import ErrorBoundary from "../ui-components/ErrorBoundary";
import { DEFAULT_SCATTERMAP_DATA } from "../utils/constants";
import WorksiteDetailButtonGroup from "./WorksiteDetailButtonGroup";
import {
  CameraIcon,
  PencilIcon,
  ShareIcon,
  UserCircleIcon,
  ListBulletIcon,
  EyeSlashIcon,
  DocumentIcon,
  ArrowRightOnRectangleIcon,
} from "@heroicons/react/24/solid";
import WorksiteDetailNewServicesList from "../components/WorksiteDetailNewServiceList";
import WorksiteUploadImageModal from "../components/Modals/WorksiteUploadImageModal";
import WorksiteDeleteModal from "../components/Modals/WorksiteDeleteModal";
import { WorksiteTerminateModal } from "@feature/worksites/terminate-modal";
import WorksiteDeactivateModal from "../components/Modals/WorksiteDeacrivateModal";
import WorksiteAbandonModal from "../components/Modals/WorksiteAbandonModal";
import WorksiteShareModal from "../components/Modals/WorksiteShareModal";
import PermanentSurvey from "./PermanentSurvey";
import WorksiteImageModal from "../components/Modals/WorksiteImageModal";
import Button from "../ui-components/Button";
import ModalPortal from "../components/ModalPortal";
import Modal from "../ui-components/Modal";
import PrivateImage from "../components/PrivateImage";
import AuthenticationService from "../services/AuthenticationService";
import KerakollContactsModal from "../components/Modals/KerakollContactsModal";
import StatusWorksite from "../components/StatusWorksite";
import apiRequest from "../services/apiRequest";
import { sharingInfoButton } from "../components/SharingInfoButton";
import { sharingInfoModal } from "../components/Modals/SharingInfoModal";
import _ from "lodash";
import { useMediaQuery } from "../hooks/useMediaQuery";
import { checkIfReferenceClosed } from "../utils/worksiteReferencesUtils";
import { ClipboardDocumentListIcon, GlobeAltIcon } from "@heroicons/react/24/outline";
import WorksiteNotesSection from "../components/WorksiteNotesSection";
import UserNotificationsContext from "../UserNotificationsContext";
import NotificationsCount from "../ui-components/NotificationsCount";
import { QuestionMarkCircleIcon } from "@heroicons/react/20/solid";
import { get_current_status, set_worksite_status } from "../utils";
import CloseIcon from "../components/CloseIcon";
import ExportSurveyModal from "../components/Modals/ExportSurveyModal";
import {
  CreateQuotationModal,
  EditableQuotationDraft,
} from "../feature/quotations";
import {
  BudgetIcon,
  CalculatorDollarIcon,
  DesignIcon,
} from "@ui-components/icons";
import Tabs from "@ui-components/Tabs";
import {
  CreateQuotationFromDesignModal,
  EditSurveyModal,
  CreateReportModal,
} from "../feature/worksites";
import {
  useGenerateQuotationSurvey,
  useGenerateSurvey,
} from "../feature/surveys";
import CountryConfigContext from "../CountryConfigContext";
import { useQuotations } from "@feature/quotations";
import { canUserCreateQuotation } from "../feature/quotations/lib/utilities";
import { EstimeDatesModal } from "@feature/worksites/estime-dates/estime-dates-modal";
import { EstimeDatesButton } from "feature/worksites/estime-dates/estime-dates-button";
import {EditWorksiteModal} from "@feature/worksites/edit-worksite-modal";

const workSiteKeys = [
  {
    textKey: "created_by",
    key: "creator",
    render: (c, intl) => {
      return (
        <span>
          <span>
            {c.firstname} {c.lastname}{" "}
          </span>
          <span className="text-xs italic">
            ({intl.formatMessage({ id: c.account_user?.role.name || c.role.name })})
          </span>
        </span>
      );
    },
  },
  { textKey: "shared_with", key: "shared_with" },
  { textKey: "address", key: "address" },
  { textKey: "worksite_city", key: "city" },
  { textKey: "worksite_province", key: "des_province" },
  { textKey: "worksite_state", key: "des_state" },
  { textKey: "worksite_type", key: "cod_worksite_type" },
  { textKey: "worksite_construction", key: "cod_worksite_construction" },
  { textKey: "worksite_seismic_zone", key: "des_seismic_classification" },
  {
    textKey: "worksite_execution_date",
    key: "des_execution_date",
    render: (setOpenModal, worksite) => (
      <EstimeDatesButton
        setShowEstimeDates={setOpenModal}
        selectedWorksite={worksite}
      />
    ),
  },
];
const WorksiteDetail = () => {
  const intl = useIntl();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(1); // quotation is the default
  const { country } = useContext(CountryContext);
  const {
    config: { services },
  } = useContext(CountryConfigContext);
  const { userNotifications, setUserNotifications } = useContext(
    UserNotificationsContext
  );
  const userData = AuthenticationService.getUserData();
  const userScopes = AuthenticationService.getUserScopes();
  const accountUserScopes = AuthenticationService.getAccountUserScopes();

  //WORSITES DATA
  const [selectedWorksite, setSelectedWorksite] = useState();
  const [creators, setCreators] = useState();
  const [sharing, setSharing] = useState();
  const [worksiteImageData, setWorksiteImageData] = useState([]);
  const [worksiteTypes, setWorksiteTypes] = useState();
  const [scatterData, setScatterData] = useState(DEFAULT_SCATTERMAP_DATA);
  const { worksite_id, note_id } = useParams();
  const [servicesSurveys, setServicesSurveys] = useState(null);
  const [showImagesModal, setShowImagesModal] = useState(false);
  const [activeModalImage, setActiveModalImage] = useState(null);
  const [showImagesUploadModal, setShowImagesUploadModal] = useState(false);
  const [showDeleteWorksiteModal, setShowDeleteWorksiteModal] = useState(false);
  const [showTerminateWorksiteModal, setShowTerminateWorksiteModal] =
    useState(false);
  const [showAbandonWorksiteModal, setShowAbandonWorksiteModal] =
    useState(false);
  const countryApiRequest = useCountryAxiosInstance();
  const { push } = useContext(NotificationsContext);
  const [deleteSurvey, setDeleteSurvey] = useState(null);
  const [deletingSurvey, setDeletingSurvey] = useState(false);
  const [showNewWorksiteDialog, setShowNewWorksiteDialog] = useState(false);
  const [showShareWorksiteDialog, setShowShareWorksiteDialog] = useState(false);
  const [
    showReportsSelectionWorksiteDialog,
    setShowReportsSelectionWorksiteDialog,
  ] = useState(false);
  const [showQuotationDialog, setShowQuotationDialog] = useState(false);
  const [estimeDatesQuotationCheck, setEstimeDatesQuotationCheck] =
    useState(false);
  const [showNotesSection, setShowNotesSection] = useState(!!note_id);
  const [showKerakollContacts, setShowKerakollContacts] = useState(false);
  const [showSharing, setShowSharing] = useState();
  const [references, setReferences] = useState();
  const [showReferencesInstructions, setShowReferencesInstructions] =
    useState(false);
  const [showDeactivateWorksiteModal, setShowDeactivateWorksiteModal] =
    useState(false);
  const [apExportSurvey, setApExportSurvey] = useState(null);
  const [quotationTemporaryState, setQuotationTemporaryState] = useState(null);
  const [createFromDesignModalData, setCreateFromDesignModalData] =
    useState(null);
  const [editedSurveyData, setEditedSurveyData] = useState();
  const [showEstimeDates, setShowEstimeDates] = useState(false);
  const [canRemoveSharing, setCanRemoveSharing] = useState(false);

  useEffect(() => {
    if (userData && selectedWorksite) {
      setCanRemoveSharing(
        userData["id"] == selectedWorksite.id_creator ||
          userData.role_type == "admin"
      );
    }
  }, [selectedWorksite, userData]);

  const { dispatch: generateQuotation, loading: generatingQuotation } =
    useGenerateQuotationSurvey();
  const {
    upsert: upsertSurvey,
    submitting: submittingSurvey,
    setSubmitting: setSubmittingSurvey,
  } = useGenerateSurvey(selectedWorksite);
  const { loading, requestQuotation } = useQuotations();

  const onSurveyCreated = async (serviceId, surveyId) => {
    // navigate to new survey
    history.push(
      `/${country.code}/worksites/${worksite_id}/service/${serviceId}/survey/${surveyId}`
    );
  };
  const generateQuotationFromDesignSurveys = async (surveys, qsid, name) => {
    if (!surveys?.length)
      throw new Error(
        "At least one survey must be selected to generate a quotation"
      );
    const qsav = services.find((s) => s.id === qsid).active_version;
    const newSurvey = await generateQuotation(surveys, qsid, qsav, name);

    // add newly created survey to servicesSurveys and move to quotation tab
    setServicesSurveys((prev) => [newSurvey, ...prev]);
    setActiveTab(1 /* Quotation */);
    onSurveyCreated(qsid, newSurvey.id);
  };
  const forceWorksiteStatusToDesign = async () => {
    const { id: worksiteId, cod_worksite_status: currentStatus } =
      selectedWorksite;
    const openStep = {
      step: "design",
      flg_active: false,
      date: Math.floor(new Date().getTime() / 1000),
      author: userData.firstname + " " + userData.lastname,
      reason: "",
      id: 2,
      flg_current: false,
    };
    const payload = set_worksite_status(currentStatus, openStep, userData);
    const result = await countryApiRequest.put(
      `/worksites/${worksiteId}/update_status`,
      payload
    );
    setSelectedWorksite(result);
  };

  const worksiteState = selectedWorksite
    ? get_current_status(intl, selectedWorksite.cod_worksite_status)
    : {};

  const isWindowMoreThanXS = useMediaQuery("(min-width: 640px)");

  const toggleNewWorksiteUploadImageDialog = () =>
    setShowImagesUploadModal(!showImagesUploadModal);

  // const toggleDeleteWorksiteDialog = () =>
  //   setShowDeleteWorksiteModal(!showDeleteWorksiteModal);

  const toggleTerminateWorksiteDialog = () =>
    setShowTerminateWorksiteModal(!showTerminateWorksiteModal);

  // const toggleDeactivateWorksiteDialog = () =>
  //   setShowDeactivateWorksiteModal(!showDeactivateWorksiteModal);


  const toggleAbandonWorksiteDialog = () =>
    setShowAbandonWorksiteModal(!showAbandonWorksiteModal);


  const toggleEditWorksiteDialog = () =>
    setShowNewWorksiteDialog(!showNewWorksiteDialog);

  const toggleShareWorksiteDialog = () =>
    setShowShareWorksiteDialog(!showShareWorksiteDialog);

  const toggleNotesSection = () => setShowNotesSection((prev) => !prev);

  const toggleShowReportsSelectionWorksiteDialog = () =>
    setShowReportsSelectionWorksiteDialog(!showReportsSelectionWorksiteDialog);

  const toggleKerakollContactsDialog = () =>
    setShowKerakollContacts(!showKerakollContacts);

  const fetchServiceSurveys = useCallback(async () => {
    return countryApiRequest.get(
      `/service_surveys/by_worksite/${worksite_id}`,
      { params: { join: "services" } }
    );
  }, [countryApiRequest, worksite_id]);

  const updateServicesSurveys = useCallback(async () => {
    try {
      const data = await fetchServiceSurveys();
      setServicesSurveys(data);
    } catch (error) {
      push({
        title: intl.formatMessage({ id: "server_error" }),
        type: "error",
      });
    }
  }, [push, fetchServiceSurveys, setServicesSurveys, intl]);

  useEffect(() => {
    // if the worksite has never been seen by the current user, delete the 'new worksite' notification
    const notificationsToRemove = userNotifications
      ?.filter(
        (n) =>
          ["worksite", "worksite_sharing"].includes(n.val_type) &&
          n.cod_worksite === parseInt(worksite_id)
      )
      ?.map((n) => n.id);
    if (notificationsToRemove)
      setUserNotifications((prev) =>
        prev.filter((n) => !notificationsToRemove.includes(n.id))
      );

    let cancel = false;
    const fetchServicesSurveys = async () => {
      try {
        const data = await fetchServiceSurveys();
        if (!cancel) {
          setServicesSurveys(
            data.map((s) => ({
              ...s,
              isNew: userNotifications?.some(
                (n) => n.val_type === "worksite_survey" && n.cod_survey === s.id
              ),
            }))
          );
        }
      } catch (error) {
        push({
          title: intl.formatMessage({ id: "server_error" }),
          type: "error",
        });
      }
    };
    fetchServicesSurveys();

    return () => {
      cancel = true;
    };
    // eslint-disable-next-line
  }, [JSON.stringify(userNotifications)]);

  const fetchWorksite = useCallback(async () => {
    const loadedOn = new Date();
    try {
      const _selectedWorksite = await countryApiRequest.get(
        `/worksites/` + worksite_id
      );
      // add load timestamp to each image in order to be able to invalidate source later
      _selectedWorksite["images_urls"]["data"] =
        _selectedWorksite.images_urls.data.map((img) => ({
          ...img,
          loadedOn,
        }));
      setSelectedWorksite(_selectedWorksite);
      setWorksiteImageData(_selectedWorksite.images_urls.data);
    } catch (error) {
      console.log("errore", error);
    }
  }, [countryApiRequest, worksite_id]);

  const fetchWorksiteTypes = useCallback(async () => {
    try {
      const [allWorksiteTypes] = await Promise.all([
        countryApiRequest.get(`/worksite_types/all`),
      ]);
      setWorksiteTypes(allWorksiteTypes);
    } catch (error) {
      console.log("errore", error);
    }
  }, [countryApiRequest]);

  useEffect(() => {
    fetchWorksite();
    fetchWorksiteTypes();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchReferences = async () => {
      try {
        const references = await countryApiRequest.get(
          `/worksites_references/all?cod_worksite_id=${worksite_id}&flg_active=true`
        );
        let result = [];
        if (references?.length > 0) {
          const approvals = await Promise.all(
            references.map(
              async ({ id }) =>
                await countryApiRequest.get(
                  `/worksites_references_approvals/all?cod_reference_id=${id}`
                )
            )
          );
          result = references.map((r, idx) => ({
            id: r.id,
            title: r.content?.title,
            closed: checkIfReferenceClosed(approvals[idx]),
          }));
        }
        setReferences(result);
      } catch (error) {
        push({
          type: "error",
          title: intl.formatMessage({ id: "server_error" }),
        });
        throw error;
      }
    };

    fetchReferences();
    // eslint-disable-next-line
  }, []);

  const fetchSharing = () => {
    countryApiRequest
      .post("/share/from_worksites", { ids: [selectedWorksite["id"]] })
      .then((res) => {
        setSharing((res || []).length ? res[0]["sharing"] : []);
      })
      .catch((err) => {
        console.log("errore", err);
      });
  };
  useEffect(() => {
    if (selectedWorksite) {
      fetchSharing();
    }
    // eslint-disable-next-line
  }, [selectedWorksite]);

  useEffect(() => {
    if (selectedWorksite && sharing && servicesSurveys) {
      let ids_creators = [
        ...new Set([selectedWorksite["id_creator"], userData.id]),
      ];
      Object.values(sharing).forEach((j) => {
        if (!ids_creators.includes(j["to_user_id"])) {
          ids_creators.push(j["to_user_id"]);
        }
      });
      Object.values(servicesSurveys).forEach((j) => {
        ["id_creator", "id_modifier"].forEach((k) => {
          if (j[k] && !ids_creators.includes(j[k])) {
            ids_creators.push(j[k]);
          }
        });
      });

      const fetchCreators = async () => {
        try {
          let res = await apiRequest.post("/creators", { ids: ids_creators });
          setCreators(
            (res || []).reduce((obj, user) => _.set(obj, [user.id], user), {})
          );
        } catch (e) {
          console.error(e);
        }
      };

      fetchCreators();
    }
    // eslint-disable-next-line
  }, [sharing, selectedWorksite, servicesSurveys]);

  const newReferencesNotifications = userScopes.includes("reference:read")
    ? userNotifications?.filter(
        (n) =>
          n.val_type === "worksite_reference" &&
          n.cod_worksite === parseInt(worksite_id)
      )
    : null;
  const newNotesNotificationsCount = userNotifications?.filter(
    (n) =>
      n.val_type === "worksite_note" && n.cod_worksite === parseInt(worksite_id)
  )?.length;
  const taskNotificationsCount = userNotifications?.filter(
    (n) =>
      [
        "worksites_tasks",
        "worksites_tasks_activities",
        "worksite_task_suggestion",
      ].includes(n.val_type) && n.cod_worksite === parseInt(worksite_id)
  )?.length;

  const canWipeoutWorksite =
    userScopes.includes("worksites:delete") && selectedWorksite?.flg_test;
  const canDeactivateWorksite =
    selectedWorksite?.id_creator === userData.id ||
    userScopes.includes("worksites:delete");
  const canTerminateWorksite =
    selectedWorksite?.id_creator === userData.id ||
    userScopes.includes("worksites:terminate");
  const canAbandonWorksite =
    selectedWorksite &&
    !canDeactivateWorksite  &&
    selectedWorksite.r_perm.includes(`user_${userData.id}`);

  const showQuotationButton = canUserCreateQuotation(accountUserScopes || userScopes);

  /**
   * Remove the share of the worksite only if the user is admin or the creator.
   * If not return false otherwise return the removing function
   * @param {*} user
   * @returns
   */
  const removeSharing = canRemoveSharing
    ? async (user) => {
        try {
          const payload = {
            worksite_id: selectedWorksite.id,
            to_user_id: user["id"],
            hierarchy: user["role_hierarchy"],
          };
          const { message } = await countryApiRequest.post("/share/remove", payload);
          if (message == "already_removed") {
            push({
              title: intl.formatMessage({ id: "share_already_removed" }),
              type: "error",
            });
          } else {
            push({
              title: intl.formatMessage({
                id: "share_removed_success",
                defaultMessage: "Condivisione rimossa",
              }),
              type: "success",
            });
          }
          // Condition to refresh worksite sharing information
          setShowSharing(showSharing.filter(el=>el.id!=user.id))
          await fetchSharing();
        } catch (e) {
          push({
            title: intl.formatMessage({ id: "server_error" }),
            type: "error",
          });
          console.error(e);
        }
      }
    : false;

  return (
    <Fragment>
      <div className="min-h-full pb-12 flex flex-col bg-white">
        <main className="flex-grow flex flex-col justify-center w-full mx-auto">
          <PageHeading
            title={intl.formatMessage({ id: "worksite" })}
            historyBackPath={`/${country.code}/worksites`}
            contentActions={
              <>
                <Button
                  color="primary"
                  textCls="text-xxs xl:text-sm"
                  onClick={toggleNewWorksiteUploadImageDialog}
                >
                  <CameraIcon
                    className="-ml-0.5 mr-1 h-4 w-4"
                    aria-hidden="true"
                  />
                  <FormattedMessage id="manage_images" />
                </Button>
                <Button
                  color="primary"
                  textCls="text-xxs xl:text-sm"
                  onClick={() =>
                    history.replace({
                      pathname: `/${country.code}/worksites/${worksite_id}/tasks`,
                    })
                  }
                >
                  <ListBulletIcon
                    className="-ml-0.5 mr-1 h-4 w-4"
                    aria-hidden="true"
                  />
                  <FormattedMessage id="tasks" />
                  <NotificationsCount
                    count={taskNotificationsCount}
                    marginLeftCls="ml-1"
                  />
                </Button>
                {/*{canWipeoutWorksite && (*/}
                {/*  <Button*/}
                {/*    color="primary"*/}
                {/*    onClick={toggleDeleteWorksiteDialog}*/}
                {/*    textCls="text-xxs xl:text-sm"*/}
                {/*  >*/}
                {/*    <XCircleIcon*/}
                {/*      className="-ml-0.5 mr-1 h-4 w-4"*/}
                {/*      aria-hidden="true"*/}
                {/*    />*/}
                {/*    <FormattedMessage id="delete" />*/}
                {/*  </Button>*/}
                {/*)}*/}
                {!selectedWorksite?.terminated && canTerminateWorksite && (
                  <Button
                    color="primary"
                    textCls="text-xxs xl:text-sm"
                    onClick={toggleTerminateWorksiteDialog}
                  >
                    <FormattedMessage id="terminate" defaultMessage="Termina" />
                  </Button>
                )}
                {/*{worksiteState !== "deactivated" && canDeactivateWorksite && (*/}
                {/*  <Button*/}
                {/*    color="primary"*/}
                {/*    textCls="text-xxs xl:text-sm"*/}
                {/*    onClick={toggleDeactivateWorksiteDialog}*/}
                {/*  >*/}
                {/*    <TrashIcon*/}
                {/*      className="-ml-0.5 mr-1 h-4 w-4"*/}
                {/*      aria-hidden="true"*/}
                {/*    />*/}
                {/*    <FormattedMessage id="deactivate" />*/}
                {/*  </Button>*/}
                {/*)}*/}
                {worksiteState !== "deactivated" &&
                  canAbandonWorksite && (
                    <Button
                      textCls="text-xxs xl:text-sm"
                      color="primary"
                      onClick={toggleAbandonWorksiteDialog}
                    >
                      <ArrowRightOnRectangleIcon
                        className="-ml-0.5 mr-1 h-4 w-4"
                        aria-hidden="true"
                      />
                      <FormattedMessage id="abandon" />
                    </Button>
                  )}
                <Button
                  textCls="text-xxs xl:text-sm"
                  color="primary"
                  onClick={toggleEditWorksiteDialog}
                >
                  <PencilIcon
                    className="-ml-0.5 mr-1 h-4 w-4"
                    aria-hidden="true"
                  />
                  <FormattedMessage id="edit" />
                </Button>
                <Button
                  textCls="text-xxs xl:text-sm"
                  color="primary"
                  onClick={toggleShareWorksiteDialog}
                >
                  <ShareIcon
                    className="-ml-0.5 mr-1 h-4 w-4"
                    aria-hidden="true"
                  />
                  <FormattedMessage id="share" />
                </Button>
                <Button
                  textCls="text-xxs xl:text-sm"
                  color="primary"
                  onClick={toggleNotesSection}
                >
                  <ClipboardDocumentListIcon
                    className="-ml-0.5 mr-1 h-4 w-4"
                    aria-hidden="true"
                  />
                  <FormattedMessage id="notes" />
                  <NotificationsCount
                    count={newNotesNotificationsCount}
                    marginLeftCls="ml-1"
                  />
                </Button>
                {showQuotationButton && (
                  <Button
                    textCls="text-xxs xl:text-sm"
                    color="primary"
                    onClick={() => {
                      if (
                        !selectedWorksite?.estime_date_start ||
                        !selectedWorksite?.estime_date_end
                      ) {
                        setShowEstimeDates(true);
                        setEstimeDatesQuotationCheck(true);
                      } else {
                        setShowQuotationDialog(true);
                      }
                    }}
                    disabled={!servicesSurveys || !creators}
                    Icon={BudgetIcon}
                  >
                    <FormattedMessage id="quotation" />
                  </Button>
                )}
                <Button
                  color="primary"
                  textCls="text-xxs xl:text-sm"
                  onClick={() =>
                    history.replace({
                      pathname: `/${country.code}/worksites/${worksite_id}/documents`,
                    })
                  }
                >
                  <DocumentIcon
                    className="-ml-0.5 mr-1 h-4 w-4"
                    aria-hidden="true"
                  />
                  <FormattedMessage id="documents" />
                  <NotificationsCount
                    count={taskNotificationsCount}
                    marginLeftCls="ml-1"
                  />
                </Button>
              </>
            }
          />
          <div className="border-am-700 border-t mb-5" />
          <h1 className="text-4xl mb-2">{selectedWorksite?.des_worksite}</h1>
          <h2 className="text-2xl my-2">
            <FormattedMessage id="details" />
          </h2>
          {selectedWorksite && creators && (
            <div className="status-worksite pb-5 mb-3">
              <StatusWorksite
                className="w-full"
                author={creators[selectedWorksite["id_creator"]]}
                {...{
                  selectedWorksite,
                  setSelectedWorksite,
                  userData,
                  scopes: userScopes,
                  references,
                  newReferencesNotifications,
                }}
              />
            </div>
          )}
          <div className="grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-12">
            {scatterData && (
              <div className="flex flex-col bg-white rounded-lg divide-y divide-gray-200 col-span-12 lg:col-span-12 xl:col-span-8 2xl:col-span-8">
                <div
                  style={{ paddingBottom: isWindowMoreThanXS ? "25%" : "56%" }}
                  className="w-full flex items-center justify-between relative h-72 lg:h-full mb-4 xl:mb-0 overflow-hidden"
                >
                  <ScatterMap
                    id="worksite-scatter-map"
                    data={
                      !!selectedWorksite
                        ? [{
                          business: selectedWorksite.business,
                          category: "created_not_shared",
                          worksite_id: selectedWorksite.id,
                          worksite_name: selectedWorksite.des_worksite,
                          latitude: selectedWorksite.latitude,
                          longitude: selectedWorksite.longitude,
                          count: 1,
                        }]
                        : undefined
                    }
                    initialViewport={
                      !!selectedWorksite
                        ? {
                          latitude: selectedWorksite.latitude,
                          longitude: selectedWorksite.longitude,
                          zoom: 15,
                        }
                        : undefined
                    }
                    draggable={true}
                    deactivatedCategories={new Set()}
                  />
                </div>
              </div>
            )}
            {selectedWorksite && creators && (
              <div className="bg-white col-span-12 lg:col-span-6 xl:col-span-4 2xl:col-span-4">
                {Object.keys(userData.ref_users || {}).length > 0 ? (
                  <div className="mt-1">
                    <Button
                      onClick={toggleKerakollContactsDialog}
                      styleType="empty"
                    >
                      <UserCircleIcon
                        className="-ml-3 h-5 w-5"
                        aria-hidden="true"
                      />
                      <span className="ml-2 -mr-3 text-xs">
                        {intl.formatMessage({ id: "kerakoll_contacts" })}
                      </span>
                    </Button>
                  </div>
                ) : null}
                <WorksiteDetailButtonGroup
                  scopes={userScopes}
                  selectedWorksite={selectedWorksite}
                  userData={userData}
                  references={references}
                  newReferencesNotifications={newReferencesNotifications}
                />
                <div className="flex flex-row mb-6 text-xs">
                  <div className="w-1/2 text-xs">
                    <a
                      className="flex items-center gap-3 text-gray-700 capitalize underline"
                      href={`https://maps.google.com/maps?q=${selectedWorksite["latitude"]},${selectedWorksite["longitude"]}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={process.env.PUBLIC_URL + "/car.svg"}
                        alt="directions car"
                        className="w-6 h-6"
                      />
                      <FormattedMessage id="directions" />
                    </a>
                  </div>
                  {userScopes.includes("reference:read") && (
                    <div
                      className="flex w-1/2 text-xs items-center gap-2 text-gray-700 underline cursor-pointer"
                      onClick={() => {
                        setShowReferencesInstructions(true);
                      }}
                    >
                      <QuestionMarkCircleIcon className="w-6 text-black" />
                      <FormattedMessage id="references_instructions" />
                    </div>
                  )}
                  {selectedWorksite.flg_test && (
                    <div className="ml-auto my-2 grid place-content-center">
                      <EyeSlashIcon className="w-7 h-7 mb-2 mx-auto" />
                      {intl.formatMessage({ id: "worksite_istest" })}
                    </div>
                  )}
                </div>
                {workSiteKeys.map(({ key, textKey, render }) => {
                  let renderFunction = render;

                  switch (key) {
                    case "shared_with": {
                      renderFunction = sharingInfoButton(
                        (sharing || []).map((i) => creators[i["to_user_id"]]),
                        setShowSharing,
                        intl
                      );
                      break;
                    }
                    case "des_execution_date": {
                      renderFunction = render(
                        setShowEstimeDates,
                        selectedWorksite
                      );
                      break;
                    }
                    default: {
                      renderFunction = render
                        ? render(creators[selectedWorksite["id_creator"]], intl)
                        : selectedWorksite[key] &&
                          intl.formatMessage({ id: selectedWorksite[key] });
                    }
                  }

                  return (
                    <div key={key} className="flex mb-6">
                      <div className="w-1/2 pr-4">
                        <p className="text-sm font-semibold text-am-700">
                          {intl.formatMessage({ id: textKey })}
                        </p>
                      </div>
                      <div className="w-1/2">
                        <div className="uppercase text-sm text-black-500">
                          {renderFunction}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {showReportsSelectionWorksiteDialog ? (
              <CreateReportModal
                worksite={selectedWorksite}
                onClose={() => {
                  setShowReportsSelectionWorksiteDialog(false);
                }}
                servicesSurveys={servicesSurveys.filter((i) => i.complete)}
                creators={creators}
                sharing={sharing}
                images={selectedWorksite?.["images_urls"]?.data}
              />
            ) : null}
            <div className="col-span-12 w-full flex flex-wrap mt-3 mb-2">
              {selectedWorksite?.["images_urls"]?.data?.map(
                ({ image_url, loadedOn }, index) => (
                  <div
                    key={image_url}
                    className="flex flex-col w-32 mr-4 mb-4 cursor-pointer hover:opacity-80"
                    onClick={() => {
                      setActiveModalImage(index);
                      setShowImagesModal(true);
                    }}
                  >
                    <PrivateImage
                      image_url={image_url}
                      tag={"div"}
                      className={
                        "mb-2 w-full flex flex-col bg-white rounded-lg shadow bg-cover"
                      }
                      {...{ loadedOn: new Date(loadedOn) }}
                    />
                  </div>
                )
              )}
            </div>
          </div>
          {selectedWorksite && creators ? (
            <Fragment>
              <div className="max-w-2xl mb-3">
                <Tabs
                  tabs={[
                    [
                      DesignIcon,
                      "design_services_tab_title",
                      "Progettazione intervento",
                    ],
                    [
                      CalculatorDollarIcon,
                      "quotation_services_tab_title",
                      "Definizione intervento",
                    ],
                    // [
                    //   GlobeAltIcon,
                    //   "service_services_tab_title",
                    //   "Servizi",
                    // ],  // TODO uncomment this when services of type "service" are going to be public
                  ].map(([Icon, id, defaultMessage]) => ({
                    name: intl.formatMessage({ id, defaultMessage }),
                    Icon,
                  }))}
                  fullButtons={true}
                  active={activeTab}
                  setActiveTab={setActiveTab}
                />
              </div>
              {/*SERVICES LIST*/}
              <WorksiteDetailNewServicesList
                worksite={selectedWorksite}
                updateServicesSurveys={updateServicesSurveys}
                servicesSurveys={servicesSurveys}
                setServicesSurveys={setServicesSurveys}
                setDeleteSurvey={setDeleteSurvey}
                userData={userData}
                creators={creators}
                setApExportSurvey={setApExportSurvey}
                setCreateFromDesignModalData={setCreateFromDesignModalData}
                setEditedSurveyData={setEditedSurveyData}
                activeTab={activeTab}
                submittingSurvey={submittingSurvey}
              />
            </Fragment>
          ) : null}
        </main>
      </div>
      {!!apExportSurvey && (
        <ExportSurveyModal
          survey={apExportSurvey}
          onDismiss={() => setApExportSurvey(null)}
        />
      )}

      {!!showQuotationDialog && (
        <CreateQuotationModal
          worksite={selectedWorksite}
          fetchWorksite={fetchWorksite}
          creators={creators}
          surveys={servicesSurveys?.filter(
            (i) => i.complete && i.services.class === 1 /* Quotazione */
          )}
          onDismiss={() => {
            setShowQuotationDialog(false);
          }}
          onConfirm={async (state) => {
            if (
              (userScopes.includes("quotation:create_draft") &&
              userScopes.includes("quotation:create")) ||
              (accountUserScopes?.includes("quotation:create_draft") &&
                accountUserScopes?.includes("quotation:create"))
            ) {
              setQuotationTemporaryState(state);
              setShowQuotationDialog(false);
            } else {
              if (userScopes.includes("quotation:request")
                || accountUserScopes?.includes("quotation:request")) {
                const payload = {
                  agent: {
                    id: state.agent.id,
                    name: state.agent.name,
                    email: state.agent.email,
                  },
                  ...(state.resale && {
                    resale: {
                      id: state.resale.id,
                      name: state.resale.name,
                      company: state.resale.company,
                    },
                  }),
                  ...(state.enterprise && {
                    enterprise: {
                      id: state.enterprise.id,
                      name: state.enterprise.name,
                      company: state.enterprise.company,
                    },
                  }),
                  worksite: selectedWorksite,
                  surveys: state.surveys.map((s) => ({
                    id: s.id,
                    name: s.name,
                    service_id: s.service_id,
                    service_version: s.service_version,
                  })),
                };
                await requestQuotation(payload);
                setShowQuotationDialog(false);
              } else {
                throw new Error("User has no permission to create a quotation");
              }
            }
          }}
        />
      )}
      {!!quotationTemporaryState && (
        <EditableQuotationDraft
          {...quotationTemporaryState}
          worksite={selectedWorksite}
          onExit={() => {
            setQuotationTemporaryState(null);
          }}
        />
      )}

      {deleteSurvey ? (
        <Modal
          confirmText={intl.formatMessage({
            id: "delete",
            defaultMessage: "DELETE",
          })}
          type="warning"
          title={intl.formatMessage({
            id: "delete_survey_title",
            defaultMessage: "Are you sure?",
          })}
          // description="Lorem ipsum dolor sit amet"
          onExit={() => setDeleteSurvey(null)}
          onDismiss={() => {
            setDeleteSurvey(null);
          }}
          onConfirm={async () => {
            setDeletingSurvey(true);
            try {
              await countryApiRequest.delete(
                `/service_surveys/${deleteSurvey}`
              );
              await updateServicesSurveys();
              push({
                title: intl.formatMessage({ id: "deleted" }),
                type: "success",
              });
            } catch (error) {
              console.log("error", error);
              push({
                title: intl.formatMessage({ id: "server_error" }),
                type: "error",
              });
            } finally {
              setDeleteSurvey(null);
              setDeletingSurvey(false);
            }
          }}
          dismissText={intl.formatMessage({
            id: "cancel",
            defaultMessage: "CANCEL",
          })}
          submitting={deletingSurvey}
        />
      ) : null}
      {showImagesModal ? (
        <WorksiteImageModal
          onNextImage={() => {
            if (
              activeModalImage ===
              selectedWorksite["images_urls"].data.length - 1
            ) {
              setActiveModalImage(0);
              return;
            }
            setActiveModalImage(activeModalImage + 1);
          }}
          onPrevImage={() => {
            if (!activeModalImage) {
              setActiveModalImage(
                selectedWorksite["images_urls"].data.length - 1
              );
              return;
            }
            setActiveModalImage(activeModalImage - 1);
          }}
          image={selectedWorksite["images_urls"].data[activeModalImage]}
          closeModal={() => setShowImagesModal(false)}
        />
      ) : null}
      {showImagesUploadModal ? (
        <WorksiteUploadImageModal
          closeModal={() => {
            setSelectedWorksite({
              ...selectedWorksite,
              images_urls: {
                data: selectedWorksite.images_urls.data.map((i) => ({
                  ...i,
                  loadedOn:
                    worksiteImageData.find((j) => i.image_url === j.image_url)
                      ?.loadedOn ?? i.loadedOn,
                })),
              },
            });
            setShowImagesUploadModal(false);
          }}
          selectedWorksite={selectedWorksite}
          setSelectedWorksite={setSelectedWorksite}
          setWorksiteImageData={setWorksiteImageData}
          worksiteImageData={worksiteImageData}
          toggleNewWorksiteUploadImageDialog={
            toggleNewWorksiteUploadImageDialog
          }
        />
      ) : null}
      {showDeleteWorksiteModal && canWipeoutWorksite ? (
        <WorksiteDeleteModal
          closeModal={() => setShowDeleteWorksiteModal(false)}
          selectedWorksite={selectedWorksite}
          toggleDeleteWorksiteDialog={toggleDeleteWorksiteDialog}
          countryCode={country.code}
        />
      ) : null}
      {showTerminateWorksiteModal && canTerminateWorksite ? (
        <WorksiteTerminateModal
          closeModal={() => setShowTerminateWorksiteModal(false)}
          selectedWorksite={selectedWorksite}
          setSelectedWorksite={setSelectedWorksite}
        />
      ) : null}
      {showDeactivateWorksiteModal && canDeactivateWorksite ? (
        <WorksiteDeactivateModal
          closeModal={() => setShowDeactivateWorksiteModal(false)}
          onUpdate={(result) => setSelectedWorksite(result)}
          selectedWorksite={selectedWorksite}
          toggleDeactivateWorksiteDialog={toggleDeactivateWorksiteDialog}
          countryCode={country.code}
          userData={userData}
        />
      ) : null}
      {showDeactivateWorksiteModal && canDeactivateWorksite ? (
        <WorksiteDeactivateModal
          closeModal={() => setShowDeactivateWorksiteModal(false)}
          onUpdate={(result) => setSelectedWorksite(result)}
          selectedWorksite={selectedWorksite}
          toggleDeactivateWorksiteDialog={toggleDeactivateWorksiteDialog}
          countryCode={country.code}
          userData={userData}
        />
      ) : null}
      {showAbandonWorksiteModal && canAbandonWorksite ? (
        <WorksiteAbandonModal
          closeModal={() => setShowAbandonWorksiteModal(false)}
          onUpdate={(result) => setSelectedWorksite(result)}
          selectedWorksite={selectedWorksite}
          toggleAbandonWorksiteDialog={toggleAbandonWorksiteDialog}
          userData={userData}
          countryCode={country.code}
        />
      ) : null}
      {showShareWorksiteDialog ? (
        <WorksiteShareModal
          closeModal={() => setShowShareWorksiteDialog(false)}
          selectedWorksite={selectedWorksite}
          userData={userData}
          onShared={async () => {
            await fetchWorksite();
            fetchSharing();
          }}
        />
      ) : null}
      {showKerakollContacts ? (
        <KerakollContactsModal
          closeModal={() => setShowKerakollContacts(false)}
          userData={userData}
        />
      ) : null}
      {selectedWorksite &&
      showNotesSection ? (
        <div
          className={`animate-slideIn flex flex-col w-full sm:w-1/2 lg:w-1/3 fixed z-30 inset-y-0 right-0 bg-white overflow-y-auto px-8 shadow-2xl pb-8`}
        >
          <PageHeading
            title={intl.formatMessage({ id: "notes" })}
            titleWrap={false}
            contentActions={
              <>
                <CloseIcon
                  onClick={() => {
                    setShowNotesSection(false);
                  }}
                  text="close"
                />
              </>
            }
          />
          <div className="relative grow-1 overflow-y-hidden flex flex-col">
            <WorksiteNotesSection
              worksite={selectedWorksite}
              highlightedNoteId={parseInt(note_id)}
            />
          </div>
        </div>
      ) : null}
      {selectedWorksite && (
        <Route
          exact
          path={`/${country.code}/worksites/${selectedWorksite["id"]}/service/:serviceId/survey/:surveyId`}
          render={() => {
            return (
              <ModalPortal>
                <PermanentSurvey
                  worksite={selectedWorksite}
                  returnPath={`/${country.code}/worksites/${selectedWorksite["id"]}`}
                  userData={userData}
                  updateServicesSurveys={updateServicesSurveys}
                />
              </ModalPortal>
            );
          }}
        />
      )}
      {showNewWorksiteDialog && (
        <div className="w-full flex items-center justify-between">
          <ErrorBoundary from="worksite-add-dialog">
            <EditWorksiteModal
              onSuccess={(worksite) => {
                setSelectedWorksite(worksite);
                setShowNewWorksiteDialog(false);
              }}
              onClose={() => setShowNewWorksiteDialog(false)}
              worksite={selectedWorksite}
              worksiteTypes={worksiteTypes}
            />
          </ErrorBoundary>
        </div>
      )}
      {showSharing?.length > 0
        ? sharingInfoModal(showSharing, setShowSharing, removeSharing, intl)
        : null}

      {!!createFromDesignModalData && (
        <CreateQuotationFromDesignModal
          quotationServices={createFromDesignModalData.quotationServices}
          onConfirm={async (qsid) => {
            const designSurvey = servicesSurveys.find(
              (i) => i.id === createFromDesignModalData.surveyId
            );
            const name = `${designSurvey.name} - ${intl.formatMessage({
              id: "quotation_service",
            })}`;
            await generateQuotationFromDesignSurveys(
              [designSurvey],
              qsid,
              name
            );
            setCreateFromDesignModalData(null);
          }}
          onClose={() => {
            setCreateFromDesignModalData(null);
          }}
          submitting={generatingQuotation}
        />
      )}

      {!!editedSurveyData && (
        <EditSurveyModal
          survey={editedSurveyData.survey}
          designSurveys={editedSurveyData.designSurveys}
          services={services}
          creators={creators}
          onClose={() => {
            setEditedSurveyData(null);
          }}
          onConfirm={async (name, designSurveys) => {
            setSubmittingSurvey(true);
            try {
              const { service, survey } = editedSurveyData;
              if (designSurveys.length > 0) {
                // CASE A: create quotation using selected design surveys; user will be redirected to the new survey
                await generateQuotationFromDesignSurveys(
                  designSurveys,
                  service.id,
                  name
                );
              } else {
                // CASE B: upsert survey
                const { id } = await upsertSurvey({ service, survey, name });
                if (!survey) {
                  // CASE B.1: create new survey
                  // update worksite status (iff it's a design service)
                  if (service.class === 0 /* Progettazione */)
                    await forceWorksiteStatusToDesign();
                  // if a new survey was created, navigate to it
                  onSurveyCreated(service.id, id);
                } else {
                  // CASE B.2: rename existing survey
                  push({
                    type: "success",
                    title: intl.formatMessage({
                      id: "name_successfully_modified",
                    }),
                  });
                }
                // refresh surveys (both in cases B.1 and B.2)
                updateServicesSurveys();
              }
              // close modal
              setEditedSurveyData(null);
            } finally {
              setSubmittingSurvey(false);
            }
          }}
          submitting={submittingSurvey}
        />
      )}
      {showEstimeDates ? (
        <EstimeDatesModal
          setOpenModal={(res) => {
            if (estimeDatesQuotationCheck) {
              setShowEstimeDates(res);
              setShowQuotationDialog(true);
              setEstimeDatesQuotationCheck(false);
            } else {
              setShowEstimeDates(res);
            }
          }}
          selectedWorksite={selectedWorksite}
          setSelectedWorksite={setSelectedWorksite}
          text={
            estimeDatesQuotationCheck
              ? intl.formatMessage({
                  id: "missing_estime_dates_quotation_warning",
                  defaultMessage:
                    "Mancano le date stimate di inizio e fine dell'esecuzione del cantiere, si consiglia di inserirle prima di creare un preventivo.",
                })
              : null
          }
          cancelText={
            estimeDatesQuotationCheck
              ? intl.formatMessage({
                  id: "proceed_anyway",
                  defaultMessage: "Procedi comunque",
                })
              : null
          }
          onClose={() => {
            setShowEstimeDates(false);
            setEstimeDatesQuotationCheck(false);
          }}
        />
      ) : null}

      <Modal
        opened={showReferencesInstructions}
        buttonText={intl.formatMessage({ id: "close" })}
        title={intl.formatMessage({ id: "references_instructions" })}
        description={intl.formatMessage({ id: "references_instructions_body" })}
        onExit={() => setShowReferencesInstructions(false)}
      />
    </Fragment>
  );
};
export default WorksiteDetail;
